import { createElement, type ReactNode } from "react";
import { OwnedPortal } from "../../components/layout/OwnedPortal";

/**
 * `createPortal` que leva a marca da tela dona (BUG-331). Mesma assinatura, e
 * devolve um ELEMENTO (não é hook): pode vir depois de `return` antecipado, como
 * os portais do app vêm. Todo portal de componente que pode morar numa tela
 * usa este, nunca `createPortal` cru — o `<Activity>` que guarda a tela não
 * esconde portal (`lib/navigation/pageOwner.ts`).
 */
export function ownedPortal(children: ReactNode, container: Element | DocumentFragment): ReactNode {
  return createElement(OwnedPortal, { container, children });
}
